import { render, staticRenderFns } from "./Meals.vue?vue&type=template&id=a418dd6c&scoped=true"
import script from "./Meals.vue?vue&type=script&lang=js"
export * from "./Meals.vue?vue&type=script&lang=js"
import style0 from "./Meals.vue?vue&type=style&index=0&id=a418dd6c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a418dd6c",
  null
  
)

export default component.exports